import type { FlexContainerLabelProps } from "./flex-container-label.type";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Space, Tooltip, Typography } from "antd";

const { Text } = Typography;

const FlexContainerLabel = ({ label, tooltip }: FlexContainerLabelProps) => {
  if (!label && !tooltip) return null;
  return (
    <Space>
      {label && <Text strong>{label}</Text>}
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoCircleOutlined />
        </Tooltip>
      )}
    </Space>
  );
};
export default FlexContainerLabel;
